export function normalizeChatRequestStatus(data) {
  return String(data ?? '');
}

export function getChatRequestFeedback(status) {
  switch (status) {
    case '3':
      return {
        shouldNavigateToMessages: false,
        shouldNavigateToChatRequests: false,
        toastType: 'info',
        messageKey: 'chat.requestPending',
      };
    case '2':
      return {
        shouldNavigateToMessages: true,
        shouldNavigateToChatRequests: false,
        toastType: 'success',
        messageKey: 'chat.redirectingToMessages',
      };
    case '1':
      return {
        shouldNavigateToMessages: false,
        shouldNavigateToChatRequests: false,
        toastType: 'error',
        messageKey: 'chat.requestRejected',
      };
    case '4':
      return {
        shouldNavigateToMessages: false,
        shouldNavigateToChatRequests: true,
        toastType: 'info',
        messageKey: 'chat.incomingRequest',
      };
    default:
      return null;
  }
}
